import { render, staticRenderFns } from "./LegalPage.vue?vue&type=template&id=1e867fc6&"
import script from "./LegalPage.vue?vue&type=script&lang=js&"
export * from "./LegalPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports